import { DAY, HOUR, MINUTE } from "./phase.ts";

const pad = (n: number) => String(n).padStart(2, "0");

/** "21d 13h", "4d 12h", "13h 09m", "42m", "8m 05s" (seconds only inside the final 10 minutes). */
export function formatTimeLeft(ms: number): string {
  if (ms <= 0) return "ended";
  const d = Math.floor(ms / DAY);
  const h = Math.floor((ms % DAY) / HOUR);
  const m = Math.floor((ms % HOUR) / MINUTE);
  const s = Math.floor((ms % MINUTE) / 1000);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${pad(m)}m`;
  if (ms < 10 * MINUTE) return `${m}m ${pad(s)}s`;
  return `${m}m`;
}

/** "just now", "4m", "3h", "2d". */
export function formatAge(ms: number | null): string {
  if (ms == null) return "never";
  if (ms < MINUTE) return "just now";
  if (ms < HOUR) return `${Math.floor(ms / MINUTE)}m`;
  if (ms < DAY) return `${Math.floor(ms / HOUR)}h`;
  return `${Math.floor(ms / DAY)}d`;
}

/** Which agenda group a lot belongs to, by its close time relative to the viewer's local calendar. */
export type AgendaBucket = "overtime" | "hour" | "today" | "tomorrow" | "week" | "later" | "none" | "closed";

export function agendaBucket(endAt: string | null, phase: string, now: Date): AgendaBucket {
  if (phase === "closed") return "closed";
  if (!endAt) return "none";
  const end = new Date(endAt);
  const left = end.getTime() - now.getTime();
  if (left <= 0) return "overtime";
  if (left <= HOUR) return "hour";
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOfDay(end) - startOfDay(now)) / DAY);
  if (days <= 0) return "today";
  if (days === 1) return "tomorrow";
  if (days < 7) return "week";
  return "later";
}

export const BUCKET_LABELS: Record<AgendaBucket, string> = {
  overtime: "Ended, result not in yet",
  hour: "Next hour",
  today: "Today",
  tomorrow: "Tomorrow",
  week: "This week",
  later: "Later",
  none: "No end time",
  closed: "Closed",
};
